<template>
    <div>
			<!--面包屑导航区域-->
            <div class="crumbs">
            	<el-breadcrumb separator="/">
				<el-breadcrumb-item>
              <i class="el-icon-s-data"></i> 绘本借阅记录
			  </el-breadcrumb-item>
            </el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="query" ref="query" >
				<div class="handle-box">
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<!--搜索与添加-->
								<el-input v-model="query.MAANAME" clearable :placeholder="'请输入绘本名称'" class="handle-input mr10" style="width: 10%;"></el-input>
								<el-input v-model="query.parentTel" clearable :placeholder="'请输入家长电话号'" class="handle-input mr10" style="width: 12%;"></el-input>
								<el-input v-model="query.childName" clearable :placeholder="'请输入宝宝名称'" class="handle-input mr10" style="width: 10%;"></el-input>
								
								<el-select v-model="query.valueSABSAAI" clearable filterable
								:placeholder="'请选择所属幼儿园'" class="handle-select mr10" style="width: 12%;" @change="getSAB(query.valueSABSAAI)">
								  <el-option
								  	v-for="item in query.optionsSABSAAI"
								  	:key="item.SAAMSID"
								  	:label="item.SAANAME"
								  	:value="item.SAAMSID">
								  </el-option>
								</el-select>
								
								<el-select v-model="query.valueSABMSID" clearable 
								:placeholder="'请选择班级名称'" class="handle-select mr10" style="width: 10%;" :disabled="HADSABIdisabled">
								  <el-option
								  	v-for="item in query.optionsSABMSID"
								  	:key="item.SABMSID"
								  	:label="item.SABNAME"
								  	:value="item.SABMSID">
								  </el-option>
								</el-select>
								
								<el-select v-model="query.valueSTAT" clearable :placeholder="'请选择借阅状态'" class="select-shop mr10" style="width: 10%;">
									<el-option 
									 v-for="item in query.optionsSTAT" 
									 :key="item.INIKEY2" 
									 :label="item.INIDISP" 
									 :value="item.INIKEY2">
									</el-option>
								</el-select>
								<el-date-picker style="width: 14%;" v-model="query.start" type="datetime" :picker-options="starttime" value-format=" yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" class="handle-input mr10" :placeholder="'预约/借阅时间1'"/>
									<span style="margin-right: 0.8%;">-</span>
									<el-date-picker style="width: 14%;" v-model="query.end" type="datetime" :picker-options="endTime" value-format=" yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" class="handle-input mr10" :placeholder="'预约/借阅时间2'"/>
							</div>
						</el-col>
						<el-col :span="2">
							<div class="grid-content bg-purple-light">
								<el-button type="warning" :disabled="!hasPerms(buttonPerms.searchPerms)" class="float" icon="el-icon-search"@click="handleSearch">搜索</el-button>
							</div>
						</el-col>
					</el-row>
				</div>
				
				<el-table ref="datalist" :data="tableData" border class="table" :default-sort="{prop: 'CCBINDT', order: 'descending'}"
				 header-cell-class-name="table-header" @selection-change="handleSelectionChange" :row-key="getRowKeys" v-loading="loading">
					<el-table-column type="index" :label="'序号'" width="80" align="center"></el-table-column>
				    <el-table-column prop="MBAMSID" :label="'绘本记录ID'"align="center" v-if='show'></el-table-column>
					<el-table-column prop="MDANAME" :label="'绘本名称'"align="center" width="150"></el-table-column>
					<el-table-column prop="HAAPHON" :label="'家长电话'" align="center" ></el-table-column>
					<el-table-column prop="HABNAME" :label="'宝宝名称'" align="center" ></el-table-column>
					<el-table-column prop="SAANAME" :label="'幼儿园名称'" align="center" ></el-table-column>
					<el-table-column prop="SABNAME" :label="'班级名称'" align="center" ></el-table-column>					
					<el-table-column prop="MBASTAT" :label="'借阅状态'" align="center" ></el-table-column>					
					<el-table-column prop="MBAYYDT" :label="'预约时间'" align="center"></el-table-column>
					<el-table-column prop="MBAJCST" :label="'借阅时间'" align="center"></el-table-column>
					<el-table-column prop="MBAJCED" :label="'借阅到期时间'" align="center"></el-table-column>
					<el-table-column prop="MBAGHDT" :label="'实际归还时间'" align="center"></el-table-column>					
					<el-table-column prop="MBAQXDT" :label="'取消时间'" align="center"></el-table-column>
					<el-table-column prop="MBAQXLY" :label="'取消理由'" align="center"></el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, prev, pager, next, jumper,sizes" :current-page="this.query.pageIndex"
					:page-sizes="[10, 50,100]" :page-size="this.query.pageSize" :total="this.pageTotal" @size-change="handleSizeChange" @current-change="handlePageChange">
					 </el-pagination>
				</div>
			</el-form>
		</div>
    </div>
</template>
<script>
import {
		hasPermission
	} from '@/permission/index.js'
	export default {
		name: 'bookMBA',
		inject: ['reload'], //在子组件中通过inject调用
		data() {
			return {
				//页面按钮权限
				buttonPerms: {
					searchPerms: 'bookMBA:bookMBA:search', //搜索权限标识
					
					disabled: false
				},
				
				web_suuid: sessionStorage.getItem("ms_web_suuid"), 
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户
				
				// 开始时间
				starttime: {
					disabledDate: time => {
					  if (this.query.end) {
						return (
						  time.getTime() > new Date(this.query.end).getTime()
						)
					  } else {
						// 不能大于当前日期
						return time.getTime() > Date.now()
					  }
					}
				},
				// 结束时间
				endTime: {
					disabledDate: time => {
						new Date(+new Date(new Date().toLocaleDateString()) + 24 * 60 * 60 * 1000 - 1)
					 //  if (this.query.start) {
						// return (
						//   time.getTime() > Date.now() ||
						//   time.getTime() < new Date(this.query.start).getTime() - 8.64e6  
						// )
					 //  } else {
						// return time.getTime() > Date.now()
					 //  }
					}
				},
				
				HADSABIdisabled: true,
				
				query: {
					MAANAME:'',         //绘本名称
					parentTel:'', 		//家长电话号
					childName:'', 		//宝宝名称
					valueSABSAAI:'', 	//幼儿园名称
					optionsSABSAAI: '',
					valueSABMSID:'', 	    //班级
					optionsSABMSID: '',
					valueSTAT:'', 	//借阅状态
					optionsSTAT: '',
					start: new Date(this.getDay(-30)), //缴费开始时间
					//start: new Date(new Date(new Date().setDate(new Date.getDate() - N)).toLocaleDateString()), //缴费开始时间
					end: new Date(+new Date(new Date().toLocaleDateString()) + 24 * 60 * 60 * 1000 - 1),  //缴费结束时间
					pageIndex: 1, 		//当前页
					pageSize: 10,//这是当前每页显示的条数
					
				},
				tableData: [],
				multipleSelection: [], // 多选操作
				pageTotal: 0, // 总条数
				loading: false
			};
		},
		created() {
			
			let curpagenum = this.query.pageIndex; //当前页码
			this.show=false;
		
			this.getSAA(); //获取幼儿园
			this.getSAB(); //获取班级
			this.getSTAT();//获取借阅状态
			this.getData(curpagenum); //获取当前列表数据
			this.get_MBA_Count(); //获取当前列表条数
		},
		mounted() {
			this.$bus.$on('change', () => {
				//刷新当前页面
				this.reload()
			})
		},
		methods: {
			//获得当前日期
			getDay(day) {
				var today = new Date();
			    var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
			    today.setTime(targetday_milliseconds); //注意，这行是关键代码
			    var tYear = today.getFullYear();
			    var tMonth = today.getMonth();
			    var tDate = today.getDate();
			    tMonth = this.doHandleMonth(tMonth + 1);
			    tDate = this.doHandleMonth(tDate);
			     return tYear + "-" + tMonth + "-" + tDate;
			},
			doHandleMonth(month) {
			    var m = month;
			    if (month.toString().length == 1) {
			        m = "0" + month;
			    }
			    return m;
			},
			
			hasPerms: function(perms) {
				// 根据权限标识和外部指示状态进行权限判断
				return hasPermission(perms) & !this.buttonPerms.disabled
			},
			//时间格式化
			dateFormat:function(val){
			　  var t=new Date(val);//row 表示一行数据, date 表示要格式化的字段名称
			　　var year=t.getFullYear(),
			　　 month=t.getMonth()+1,
			　　 day=t.getDate(),
			　　  hour=t.getHours(),
			　　  min=t.getMinutes();
			　　 var newTime=year+'-'+
			　　  (month<10?'0'+month:month)+'-'+
			　　   (day<10?'0'+day:day)+' '+
			　　  (hour<10?'0'+hour:hour)+':'+
			　　  (min<10?'0'+min:min);
			　　return newTime;
			},
			//获取班级名称
			getSAB(pSAAI) {
				const self_shop = this;
				self_shop.query.valueSABMSID = '';
				var postUrl = 'WCF/WEB/svcMBA.svc/GET_SAB_SABNAME';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sSAAI: pSAAI,
						sPHON: self_shop.web_sphon, //web侧 登录邮箱						
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if (resCount > 0) {
						this.query.optionsSABMSID = response.data.KKDT;
						this.HADSABIdisabled = false;
					}else{
						this.query.optionsSABMSID = [];
						this.HADSABIdisabled = true;
					}
				})
				.catch((error) => {
					this.$message({
						message: '获取班级名称失败',
						type: 'error'
					});
				});
			},		
			//获取幼儿园信息
			getSAA(){
				const self_agent = this;
				var postUrl='WCF/WEB/svcMAA.svc/Get_SAA_INI';
				//网络请求接口
				this.$axios.post(
					//请求的url
						postUrl,
					//请求参数
					{ 
						sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
					}
				)
				.then((response) =>{
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if(resCount>0){
						this.query.optionsSABSAAI = response.data.KKDT;
					}		
				})
				.catch((error) =>{
					this.$message({
					  message: '获取幼儿园信息请求失败',  
					  type: 'error'
					});
				});	
			},
			//获取借阅状态
			getSTAT() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcINI.svc/Get_INI_List';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sINIKEY1: 10020 
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if (resCount > 0) {
						this.query.optionsSTAT = response.data.KKDT;
					}
				})
				.catch((error) => {
					this.$message({
						message: '获取借阅状态失败', 
						type: 'error'
					});
				});
			},
			// 获取当前列表条数
			get_MBA_Count() {
				const self_count = this;
				var postUrl = 'WCF/WEB/svcMBA.svc/Get_MBA_Count';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{			
					sMAANAME:self_count.query.MAANAME,
					sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
					sHAAPHON: self_count.query.parentTel.trim(),
					sHABNAME: self_count.query.childName.trim(),
					sSABI:self_count.query.valueSABMSID,
					sSAAI:self_count.query.valueSABSAAI,
					sSTAT:self_count.query.valueSTAT,
					sSTARTDATE:this.dateFormat(self_count.query.start),
					sENDDATE: this.dateFormat(self_count.query.end),
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					this.pageTotal = Number(resCount); //总条数
				})
				.catch((error) => {
					this.$message({
						message: '获取绘本借阅记录失败', 
						type: 'error'
					});
				});
			},
			// 获取绘本借阅记录数据
			getData(curpage) {
				this.loading = true; //初始化加载loading效果
				const self_count = this;
				var postUrl = 'WCF/WEB/svcMBA.svc/Get_MBA_List';
				//debugger;
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
	                    sMAANAME:self_count.query.MAANAME,
						sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
						sHAAPHON: self_count.query.parentTel.trim(),
						sHABNAME: self_count.query.childName.trim(),
					    sSABI:self_count.query.valueSABMSID,
					    sSAAI:self_count.query.valueSABSAAI,
						sSTAT:self_count.query.valueSTAT,
						sSTARTDATE:this.dateFormat(self_count.query.start),
						sENDDATE: this.dateFormat(self_count.query.end),
						sPageIndex: curpage, //页码
						sPageSize: self_count.query.pageSize //每页显示条数
				
					})
				.then((response) => {
					this.loading = false; //取消loading效果
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					let resKKDT = response.data.KKDT;
					if (resCount > 0) {
						//渲染数据 List
						this.tableData = resKKDT; //数据数组
					} else {
						this.tableData = []; //数据数组
					}
				})
				.catch((error) => {
					this.loading = false; //取消loading效果
					this.$message({
						message: '获取绘本借阅记录失败', 
						type: 'error'
					});
				});
			},
			// 触发搜索按钮
			handleSearch() {
				
				// let sSTARTDATE = this.query.start;
				// let sENDDATE = this.query.end;
				
				// if(sSTARTDATE === null && sENDDATE !== null)
				// {
				// 	this.$alert('请选择预约/借阅时间1', '提示', {
				// 	  confirmButtonText: '确定',
				// 	  callback: action => {
				// 	  }
				// 	});
					
				// 	return false;
				// }
				// else if(sSTARTDATE !== null && sENDDATE === null)
				// {
				// 	this.$alert('请选择预约/借阅时间2', '提示', {
				// 	  confirmButtonText: '确定',
				// 	  callback: action => {
				// 	  }
				// 	});
					
				// 	return false;
				// }
				// else if(sSTARTDATE === null && sENDDATE === null)
				// {
				// 	this.$alert('请选择预约/借阅时间1和预约/借阅时间2', '提示', {
				// 	  confirmButtonText: '确定',
				// 	  callback: action => {
				// 	  }
				// 	});
					
				// 	return false;
				// }
				
				let bo = this.checkSearch();
				if(!bo){
					return false;
				}
				
				
					
				
				
				this.$set(this.query, 'pageIndex', 1);

				this.getData(1);
				this.get_MBA_Count(); //获取当前列表条数
				
				this.multipleSelection = []
				this.$refs.datalist.clearSelection();//清空列表多选框
				
			},
			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 分页导航 currentPage 改变时会触发
			handlePageChange(currentPage) {
				let bo = this.checkSearch();
				if(bo){
					this.$set(this.query, 'pageIndex', currentPage);
					// 调取列表的函数，初始化时调一次
					this.getData(currentPage);
				}
			},
			//pageSize 改变时会触发
			handleSizeChange(size) {
				this.$set(this.query, 'pageIndex', 1);
				this.$set(this.query, 'pageSize', size);
				// 调取列表的函数，初始化时调一次
				this.getData(1);
			},
			
			getRowKeys(row) {
				return row.MAAMSID; // id为列表数据的唯一标识
			},
			
			checkSearch(){
				let bo = true;
				let sSTARTDATE = this.query.start;
				let sENDDATE = this.query.end;
				
				if(sSTARTDATE === null && sENDDATE !== null)
				{
					this.$alert('请选择预约/借阅时间1', '提示', {
					  confirmButtonText: '确定',
					  callback: action => {
					  }
					});
					
					return false;
				}
				else if(sSTARTDATE !== null && sENDDATE === null)
				{
					this.$alert('请选择预约/借阅时间2', '提示', {
					  confirmButtonText: '确定',
					  callback: action => {
					  }
					});
					
					return false;
				}
				else if(sSTARTDATE === null && sENDDATE === null)
				{
					this.$alert('请选择预约/借阅时间1和预约/借阅时间2', '提示', {
					  confirmButtonText: '确定',
					  callback: action => {
					  }
					});
					
					return false;
				}
				
				return bo;
				
			}
			
			
		}
	};
</script>
<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 12%;
	}


	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.black {
		color: #000000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.select-shop {
		width: 16%;
	}

	.select-agent {
		width: 14%;
	}

	.el-row {
		margin-top: 15px;
	}

	.bg-purple {
		text-align: left;
	}

	.bg-purple-light {
		text-align: right;
	}

	.grid-content {
		min-height: 34px;
	}

	.handle-input {
		width: 250px;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
	}

	.el-upload--text {
		width: 140px;
		height: 80px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 140px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}

	.avatar {
		width: 140px;
		height: 80px;
		display: block;
	}

	.el-dialog__footer {
		text-align: center;
	}

	.dialog-footer-btn {
		margin-right: 20px;
	}

	.cropper {
		width: auto;
		height: 300px;
	}
</style>